import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: false
})
export class TimeAgoPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(iso: string | Date | null | undefined): string {
    if (!iso) {
      return '';
    }

    const date = new Date(iso);
    const time = date.getTime();

    if (Number.isNaN(time)) {
      return '';
    }

    const diff = Date.now() - time;
    const minutes = Math.floor(diff / 60000);

    if (minutes < 1) {
      return this.translate.instant('CAMPAIGN.TIME_AGO.JustNow');
    }

    if (minutes < 60) {
      const key = minutes === 1
        ? 'CAMPAIGN.TIME_AGO.Minute'
        : 'CAMPAIGN.TIME_AGO.Minutes';

      return this.translate.instant(key, { count: minutes });
    }

    const hours = Math.floor(minutes / 60);

    if (hours < 24) {
      const key = hours === 1
        ? 'CAMPAIGN.TIME_AGO.Hour'
        : 'CAMPAIGN.TIME_AGO.Hours';

      return this.translate.instant(key, { count: hours });
    }

    const days = Math.floor(hours / 24);

    const key = days === 1
      ? 'CAMPAIGN.TIME_AGO.Day'
      : 'CAMPAIGN.TIME_AGO.Days';

    return this.translate.instant(key, { count: days });
  }
}